// Mirror of `EmailGuard::TYPO_DOMAIN_MAP` / `BAD_TLDS` / `CORRECTABLE_PROVIDERS`
// in app/lib/email_guard.rb. Keep in sync.

const TYPO_DOMAIN_MAP: Record<string, string> = {
  'gmial.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'gmal.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gmaill.com': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.con': 'gmail.com',
  'gmail.cm': 'gmail.com',
  'gmail.cmo': 'gmail.com',
  'gmail.om': 'gmail.com',
  'gmail.vom': 'gmail.com',
  'hotnail.com': 'hotmail.com',
  'hotmial.com': 'hotmail.com',
  'hotmaill.com': 'hotmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmail.cm': 'hotmail.com',
  'hotmail.co': 'hotmail.com',
  'yhaoo.com': 'yahoo.com',
  'yaoo.com': 'yahoo.com',
  'yahooo.com': 'yahoo.com',
  'yaho.com': 'yahoo.com',
  'yahoo.con': 'yahoo.com',
  'yahoo.cm': 'yahoo.com',
  'outloo.com': 'outlook.com',
  'outlok.com': 'outlook.com',
  'outlook.con': 'outlook.com',
  'outlook.cm': 'outlook.com',
  'iclod.com': 'icloud.com',
  'icoud.com': 'icloud.com',
  'icloud.con': 'icloud.com',
  'proton.con': 'proton.me',
  'protonmail.con': 'protonmail.com',
};

const BAD_TLDS = new Set(['con', 'cmo', 'vom', 'om', 'ney', 'et']);

const CORRECTABLE_PROVIDERS = new Set([
  'gmail', 'hotmail', 'yahoo', 'outlook', 'icloud', 'aol', 'live', 'msn',
  'proton', 'protonmail', 'mail', 'me', 'ymail',
]);

export function suggestEmail(email: string): string | null {
  const at = email.indexOf('@');
  if (at <= 0 || at === email.length - 1) return null;

  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase();

  const fix = TYPO_DOMAIN_MAP[domain];
  if (fix) return `${local}@${fix}`;

  const dot = domain.indexOf('.');
  if (dot <= 0) return null;
  const sld = domain.slice(0, dot);
  const tld = domain.slice(dot + 1);
  if (BAD_TLDS.has(tld) && CORRECTABLE_PROVIDERS.has(sld)) {
    return `${local}@${sld}.com`;
  }

  return null;
}
